module.exports = __webpack_public_path__ + "img/nullMessageInform.22fb4770.svg";